<ngx-smart-modal #faq identifier="faq">
  <app-faq></app-faq> <app-branches></app-branches>
</ngx-smart-modal>
